'use client';

import { useEffect } from 'react';
import 'prismjs/themes/prism.css';

export default function CodeBlock() {
  useEffect(() => {
    // Dynamically import Prism.js only on client side
    const loadPrism = async () => {
      if (typeof window !== 'undefined') {
        
        const Prism = (await import('prismjs')).default;
        
        // Import additional languages
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await import('prismjs/components/prism-python' as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await import('prismjs/components/prism-javascript' as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await import('prismjs/components/prism-typescript' as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await import('prismjs/components/prism-css' as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await import('prismjs/components/prism-json' as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await import('prismjs/components/prism-bash' as any);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await import('prismjs/components/prism-sql' as any);
        
        // Highlight all code blocks
        Prism.highlightAll();
        
        // Add copy functionality to window
        (window as Window & { copyCode?: (button: HTMLElement) => void }).copyCode = (button: HTMLElement) => {
          const code = button.getAttribute('data-code');
          if (code) {
            navigator.clipboard.writeText(code).then(() => {
              const originalContent = button.innerHTML;
              button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M16.6667 5.5L7.50004 14.6667L3.33337 10.5" stroke="#28a745" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg>';
              setTimeout(() => {
                button.innerHTML = originalContent;
              }, 2000);
            }).catch(() => {
              const originalContent = button.innerHTML;
              button.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none"><path d="M15 5.5L5 15.5M5 5.5L15 15.5" stroke="#dc3545" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path></svg>';
              setTimeout(() => {
                button.innerHTML = originalContent;
              }, 2000);
            });
          }
        };
      }
    };
    
    loadPrism();
  }, []);

  return null;
}